import { isValidCharacterId } from '@shared/index'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { z } from 'zod'

const workflowSearchSchema = z.object({
  folderId: z.string().uuid().optional(),
  // Dynamic characters are created per stage, so only the ID shape is checked here.
  character: z.string().refine(isValidCharacterId).optional(),
  step: z.enum(['character', 'background', 'composition', 'retouches']).optional(),
  /** The saved generation whose prompt should be loaded into the editor. */
  runId: z.string().uuid().optional()
})

export const Route = createFileRoute('/workflow/$workflowId')({
  component: WorkflowLayout,
  validateSearch: workflowSearchSchema
})

function WorkflowLayout() {
  return <Outlet />
}
